import React, { useCallback } from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import Button from 'gatsby-theme-core/src/components/button/index';
import { useConsent } from './context';

const CookieBar = ({ className }) => {
  const { setValues, open, setOpen } = useConsent();
  const onClick = useCallback(() => {
    const values = {
      preferences: true,
      statistics: true,
      marketing: true,
    };
    setValues(values);
  }, [setValues]);
  if (!open) {
    return null;
  }
  return (
    <div className={className}>
      <Container $extraSmall>
        <Inner>
          <div>
            <Title>Wij respecteren uw privacy</Title>
            <Text>
              Wij gebruiken cookies om onze online diensten zo optimaal mogelijk te maken
              en continu te verbeteren.
            </Text>
          </div>
          <div>
            <Buttons>
              <Button
                primary
                onClick={onClick}
                eventActionResult="close"
              >
                Ok prima!
              </Button>
              <LinkButton
                link
                onClick={() => setOpen(false)}
                eventActionResult="close"
              >
                Cookies uitschakelen
              </LinkButton>
            </Buttons>
          </div>
        </Inner>
      </Container>
    </div>
  );
};

const Title = styled.strong`
  display: block;
  margin-top: 0;
  margin-bottom: .75rem;
  font-size: 1.25rem;
`;

const Text = styled.p`
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  line-height: 125%;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    display: inline-block;
    margin-right: 1.5rem;
    margin-bottom: 0;
  }
`;

const LinkButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: underline;
  font-size: .85rem;
  color: ${({ theme }) => theme.gray3};

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    margin-top: .5rem;
  }
`;

const Buttons = styled.div`

  ${Button} {
    width: 100%;
    box-sizing: border-box;
    margin-bottom: .5rem;
    white-space: nowrap;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      margin-bottom: 0;
    }
  }
`;

const Inner = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-direction: column;
  background-color: white;
  box-shadow: rgb(0 0 0 / 28%) 0px 8px 28px;
  padding: 2rem 1.25rem;
  border-radius: ${({ theme }) => theme.borderRadius};

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    align-items: center;
    flex-direction: row;
  }
`;

export default styled(CookieBar)`
  position: fixed;
  bottom: 4rem;
  left: 0;
  right: 0;
  z-index: 10000;
`;
